import React from 'react';
import styled from 'styled-components';
import { SkeletonBlock } from '../skeleton';

type TableContentLoaderProps = React.HTMLAttributes<HTMLDivElement> & { rows?: number };

const TableSkeleton = styled.div`
    width: 100%;
`;

const TableSkeletonRow = styled.div`
    display: grid;
    grid-template-columns: 40px minmax(120px, 1fr) 20px 20px;
    align-items: center;
    column-gap: 40px;
    height: 60px;
    padding: 0 20px;
    border-bottom: 1px solid ${(props) => props.theme.skeleton.backgroundColor};
`;

export const TableContentLoader = ({ rows = 20, ...props }: TableContentLoaderProps) => {
    return (
        <TableSkeleton aria-hidden='true' {...props}>
            {Array.from({ length: rows }).map((_, index) => (
                <TableSkeletonRow key={index}>
                    <SkeletonBlock $width='40px' $height='20px' />
                    <SkeletonBlock $height='20px' $radius='10px' />
                    <SkeletonBlock $width='20px' $height='20px' />
                    <SkeletonBlock $width='20px' $height='20px' />
                </TableSkeletonRow>
            ))}
        </TableSkeleton>
    );
};
